import AppError from 'errors/app-error'

export default class FetchError extends AppError {
  constructor(
    message: string = 'An error occurred while loading this page. Please refresh your browser to try again.',
  ) {
    super()
    this.statusCode = 500
    this.message = message
  }
}
